function SessionTimeoutError(message) {
  this.name = 'SessionTimeoutError'
  this.message = message
  this.stack = new Error().stack
}
SessionTimeoutError.prototype = new Error()

export default SessionTimeoutError
